// error.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'; 
import { NzMessageService } from 'ng-zorro-antd/message';
import { describeHttpError } from '../../shared/utils/http-error.util';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private messageService: NzMessageService) {}

 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  return next.handle(req).pipe(
    catchError((error: HttpErrorResponse) => {

     const bypassPatterns = [
        '/api/Authentication/me',    // all endpoints under Authentication
        '/api/Public/' ,
        '/derivatives',          // example: all public APIs
        '/protocol/openid-connect/' // Keycloak token calls: a failed silent refresh just signs the user out
      ];

      // Check if the request URL matches any bypass pattern
      const shouldBypass = bypassPatterns.some(pattern => req.url.includes(pattern));

      // If 401 and should bypass → silently throw
      if (error.status === 401 && shouldBypass) {
        return throwError(() => error);
      }
  if(shouldBypass) {
  } else {

      this.messageService.error(describeHttpError(error), { nzDuration: 6000 });
    }
      return throwError(() => error);
    })
  );
  
}
}